import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { FormControl } from "react-bootstrap";
import { Validator } from "./ValidationResult";
import PropTypes from 'prop-types';

export const CustomValidator = forwardRef(({ value, live, onValidate }, ref) => {
    const [invalid, setInvalid] = useState();
    const initialValue = useRef(value);
    const ctrlRef = useRef();

    useImperativeHandle(ref, () => ctrlRef.current);
    
    useEffect(() => {
        const result = onValidate?.(value);
        if (initialValue.current !== value) {
            setInvalid(result);
            ctrlRef.current?.setCustomValidity(result || '');
        } else {
            setInvalid();
            ctrlRef.current?.setCustomValidity('');
        }
        if (live) {
            ctrlRef.current?.checkValidity();
        }
    }, [value, live, onValidate]);

    return <div className="mx-1">
        <Validator value={value} ref={ctrlRef}>
            <FormControl ref={ctrlRef} isInvalid={invalid} type="text" value="value" style={{ display: 'none' }} onInvalid={() => setInvalid(true)}></FormControl>
        </Validator>
    </div>
})
CustomValidator.propTypes = {
    /**
     * Value to validate
     */
    value: PropTypes.any,
    /**
     * Controls whether to trigger validation when a change is detected or only on form submission
     */
    live: PropTypes.bool,
    /**
     * Function called to validate the value
     */
    onValidate: PropTypes.func
}